module.exports = __webpack_public_path__ + "img/check-circle.730957f3.svg";